import ServiceConfigurationPanel from './service-configuration-panel';

export default ServiceConfigurationPanel;
